// FONTSIZE
export const fontSize16Mixin = `
  font-size: 16px;
  line-height: 20px;
`;
export const fontSize16MixinObject = {
  fontSize: '16px',
  lineHeight: '20px',
};
export const fontSize14Mixin = `
  font-size: 14px;
  line-height: 17px;
`;
export const fontSize14MixinObject = {
  fontSize: '14px',
  lineHeight: '17px',
};
export const fontSize12Mixin = `
  font-size: 12px;
  line-height: 15px;
`;
export const fontSize12MixinObject = {
  fontSize: '12px',
  lineHeight: '15px',
};
export const fontSize20Mixin = `
  font-size: 20px;
  line-height: 24px;
`;
export const fontSize24Mixin = `
  font-size: 24px;
  line-height: 27px;
`;

// PARAGRAPH
export const paragraphMixin = `
    font-family: var(--ff-primary);
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    color: var(--c-primary);
    padding: 0;
    margin: 0;
`;
export const paragraphMixinObject = {
  fontFamily: 'var(--ff-primary)',
  fontStyle: 'normal',
  fontWeight: '700',
  fontSize: '16px',
  lineHeight: '20px',
  color: 'var(--c-primary)',
  padding: '0',
  margin: '0',
};
export const paragraph500Mixin = `
${paragraphMixin};
font-weight: 500;
`;
export const paragraph600Mixin = `
${paragraphMixin};
font-weight: 600;
`;
export const paragraph700Mixin = `
${paragraphMixin};
font-weight: 700;
`;

// TEXT OVERFLOW
export const textEllipsisFirstLineMixin = `
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
export const textEllipsisFirstLineMixinObj = {
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
};

export const textEllipsisSecondLineMixin = `
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`;
export const textEllipsisSecondLineMixinObject = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: '2',
  WebkitBoxOrient: 'vertical',
};

export const textBreakLineAllMixin = `
    word-break: break-all;
    white-space: break-spaces;
`;
export const textBreakLineAllMixinObject = {
  wordBreak: 'break-all',
  whiteSpace: 'break-spaces',
};

export const textBreakLineWordMixin = `
    word-break: break-word;
    white-space: break-spaces;
`;
export const textBreakLineWordMixinObject = {
  wordBreak: 'break-word',
  whiteSpace: 'break-spaces',
};

// SCROLL
export const scrollbarThumbMixin = `
    &::-webkit-scrollbar {
        width: 5px;
        height: 5px !important;
    }
    &::-webkit-scrollbar-thumb {
        background: var(--ds-c-grey-hover);
        border-radius: 10px;
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
`;

// DISPLAY
export const displayFlexRowCenterStartMixin = `
  display: flex;
  align-items: center;
  justify-content: start;
`;
export const displayFlexRowCenterStartMixinObject = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'start',
};

export const displayFlexRowCenterEndMixin = `
  display: flex;
  align-items: center;
  justify-content: end;
`;
export const displayFlexRowCenterEndMixinObject = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'end',
};

export const displayFlexRowCenterSpaceBetweenMixin = `
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const displayFlexRowCenterSpaceBetweenMixinObject = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const displayFlexRowCenterCenterMixin = `
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const displayFlexRowCenterCenterMixinObject = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};
export const displayFlexRowStartCenterMixinObject = {
  display: 'flex',
  alignItems: 'start',
  justifyContent: 'center',
};
export const displayFlexRowStartStartMixin = `
  display: flex;
  align-items: start;
  justify-content: start;
`;

export const displayFlexColCenterCenterMixin = `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const displayFlexColCenterCenterMixinObject = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
};
export const displayFlexColStartCenterMixin = `
 ${displayFlexColCenterCenterMixin};
  align-items: start;
`;

export const displayGridCenterCenterMixin = `
  display: grid;
  align-items: center;
  justify-items: center;
`;
export const displayGridCenterStartMixin = `
  display: grid;
  align-items: center;
  justify-items: start;
`;

// INTERACTION
export const cursorPointerMixin = `
  cursor: pointer;
  user-select: none;
`;

// SPECIAL: CSS to do something
// Prevent a dynamic text (Countdown timer ) to be jumpy/ pushing
export const preventFontJumpyMixin = `
  font-variant-numeric: tabular-nums;
`;

export const displayBlockCenter = `
  display: block;
  margin-inline: auto;
`;
